export default "__VITE_ASSET__DaetYgKn__"